import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Navbar from "../Navbar/Navbar";

export default function PrivateRoute({ children }) {
    const {role} = useAuth() || {}
    
    return (role === "student") ? 
    <>
    <Navbar/>
    {children}
    </>
      : <Navigate to="/" />;
}